import React from 'react'
import {motion} from 'framer-motion'
import { AppWrap } from '../../wrapper'
import { images } from '../../constants'
import './Header.scss'

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: 'easeInOut'
    }
  }
}

const Header = () => {
  return (
    <div className='app__header app__flex'>
      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 0.5 }}
        className='app__header-info'
      >
        <div className='app__header-badge'>
          <div className='badge-cmp app__flex'>
            <motion.span 
              animate={{ rotate: [0, 20, 0] }}
              transition={{ duration: 2, repeat: Infinity, repeatDelay: 3 }}
              className='wave-emoji'
            >
              👋
            </motion.span>
            <div className='badge-text'>
              <p className='p-text greeting-text'>Hello, Welcome to</p>
              <h3 className='brand-name'>Scoolj Institute</h3>
            </div>
          </div>

          <div className='tag-cmp app__flex'>
            <motion.h1 
              className='head-text hero-heading'
              whileInView={{ opacity: [0, 1], y: [30, 0] }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <span className='hero-line-1'>Empowering People.</span>
              <span className='hero-line-2'>Transforming Businesses.</span>
              <span className='hero-line-3'>Building Solutions.</span>
            </motion.h1>
            
            <motion.p 
              className='p-text hero-description'
              whileInView={{ opacity: [0, 1], y: [20, 0] }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              Scoolj Institute combines <span className='highlight-text'>education, technology, and business strategy</span> to deliver training, 
              digital solutions, and market expansion support that create real impact across Africa and beyond.
            </motion.p>
            
            <motion.div 
              className='app__header-cta'
              whileInView={{ opacity: [0, 1], y: [20, 0] }}
              transition={{ duration: 0.6, delay: 0.6 }}
            >
              <motion.button 
                whileHover={{ scale: 1.05, y: -3 }}
                whileTap={{ scale: 0.95 }}
                className='cta-btn primary-btn'
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              >
                <span>Get Started
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                </span>
              </motion.button>
              
              <motion.button 
                whileHover={{ scale: 1.05, y: -3 }}
                whileTap={{ scale: 0.95 }}
                className='cta-btn secondary-btn'
                onClick={() => document.getElementById('stacks')?.scrollIntoView({ behavior: 'smooth' })}
              >
                <span>Explore Scoolj Lab</span>
              </motion.button>
            </motion.div>

            <motion.div 
              className='app__header-stats'
              whileInView={{ opacity: [0, 1], y: [20, 0] }}
              transition={{ duration: 0.6, delay: 0.8 }}
            >
              <div className='stat-item'>
                <h4>500+</h4>
                <p>Students Trained</p>
              </div>
              <div className='stat-item'>
                <h4>30+</h4>
                <p>Projects Delivered</p>
              </div>
              <div className='stat-item'>
                <h4>4</h4>
                <p>Core Services</p>
              </div>
            </motion.div>
          </div>
        </div>
      </motion.div>

      <motion.div
        variants={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className='app__header-circles'
      >
        {[
          { img: images.react, label: 'Frontend' },
          { img: images.node, label: 'Backend' },
          { img: images.figma, label: 'Design' }
        ].map((tech, index) => (
          <motion.div 
            className='circle-cmp app__flex' 
            key={`circle-${index}`}
            whileHover={{ scale: 1.1, rotate: 360 }}
            transition={{ duration: 0.3 }}
          >
            <img src={tech.img} alt={tech.label} />
            <span className='tech-label'>{tech.label}</span>
          </motion.div>
        ))}
      </motion.div>
    </div>
  )
}

export default AppWrap(Header, 'home')